const INTERNAL_STAFF_EMAIL_DOMAINS = ['getro.com', 'findem.ai'];

export const isInternalStaff = (email) =>
  typeof email === 'string' &&
  INTERNAL_STAFF_EMAIL_DOMAINS.some((domain) => email.toLowerCase().endsWith(`@${domain}`));
